import axios from 'axios'
import moment from 'moment'

const state = {
  schedules: []
}

const mutations = {
  setSchedules(state, schedules) {
    state.schedules = schedules
  }
}

const actions = {
  // eslint-disable-next-line no-unused-vars
  async checkJobName({ commit }, jobDetails) {
    return axios.get(
      '/api/v1/jobSchedules/checkName?jobName=' +
        jobDetails.jobName +
        '&groupName=' +
        jobDetails.groupName
    )
  },

  // eslint-disable-next-line no-unused-vars
  async validateCRON({ commit }, cronExpression) {
    return axios.get(
      '/api/v1/jobSchedules/validateCRON?cronExpression=' + cronExpression
    )
  },

  // eslint-disable-next-line no-unused-vars
  async actionDeleteJob({ commit }, id) {
    return axios.get(
      `/api/v1/jobSchedules/${id}/delete`
    )
  },

  // eslint-disable-next-line no-unused-vars
  async actionPauseJob({ commit }, id) {
    return axios.get(
      `/api/v1/jobSchedules/${id}/pause`
    )
  },

  // eslint-disable-next-line no-unused-vars
  async actionResumeJob({ commit }, id) {
    return axios.get(
      `/api/v1/jobSchedules/${id}/resume`
    )
  },

  // eslint-disable-next-line no-unused-vars
  async actionStopJob({ commit }, id) {
    return axios.get(
      `/api/v1/jobSchedules/${id}/stop`
    )
  },

  // eslint-disable-next-line no-unused-vars
  async actionStartJob({ commit }, id) {
    return axios.get(
      `/api/v1/jobSchedules/${id}/start`
    )
  },

  // eslint-disable-next-line no-unused-vars
  async actionGetJobSchedules({ commit }, id) {
    return axios.get(
      `/api/v1/jobSchedules/${id}/schedules?`+
        'startDate=' +
        item.startDate +
        '&endDate=' +
        item.endDate +
        '&scheduleCount=' +
        item.noOfSchedules
    )
  },

  // eslint-disable-next-line no-unused-vars
  async scheduleJob({ commit }, jobDetails) {
    return axios.post('/api/v1/jobSchedules', jobDetails)
  },

  async fetchSchedules({ commit }) {
    let processResp = function(obj) {
      obj.scheduleTimeLocal = moment(obj.scheduleTime)
        .utc()
        .local()
        .format('DD MMM YYYY hh:mm:ss a')
      if (obj.lastFiredTime) {
        obj.lastFiredTimeLocal = moment(obj.lastFiredTime)
          .utc()
          .local()
          .format('DD MMM YYYY hh:mm:ss a')
      } else {
        obj.lastFiredTimeLocal = ''
      }
      obj.nextFireTimeLocal = moment(obj.nextFireTime)
        .utc()
        .local()
        .format('DD MMM YYYY hh:mm:ss a')
      return obj
    }

    let response = await axios.get('/api/v1/jobSchedules')
    let schedules = [...response.data.data]
    schedules = schedules.map(job => processResp(job))
    commit('setSchedules', schedules)
    return schedules
  }
}

export default {
  state,
  mutations,
  actions
}
